// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202601231318/js/" + chunkId + "." + {"44":"c5afc9e1","225":"f556444d","481":"fd967c67","486":"cfe85448","770":"89eba105"}[chunkId] + ".0.022362909041168333.chunk.js";
};